import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations, getTranslation, getVehicleTypeName } from '@/locales/translations';
import { readLanguageQuery, updateLanguageQuery } from '../utils/languageQuery';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(() => {
    // Get saved language from localStorage or default to Chinese
    return readLanguageQuery(Object.keys(translations)) || localStorage.getItem('language') || 'zh';
  });
  const setLanguage = (nextLanguage) => {
    if (!Object.hasOwn(translations, nextLanguage)) return;
    updateLanguageQuery(nextLanguage);
    setLanguageState(nextLanguage);
  };

  useEffect(() => {
    // Save language preference to localStorage
    localStorage.setItem('language', language);
  }, [language]);

  const t = (key) => getTranslation(language, key);
  
  const getVehicleName = (type) => getVehicleTypeName(language, type);

  const value = {
    language,
    setLanguage,
    t,
    getVehicleName,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
